import { FormEventHandler, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Magic } from "magic-sdk";
import { OAuthExtension } from "@magic-ext/oauth";
import axios from "axios";
import { UserContext } from "../lib/UserContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from 'react-modal';

const magicKey = process.env.REACT_APP_MAGIC_PUBLISHABLE_KEY || "";
const serverLink = process.env.REACT_APP_SERVER_URL;

const EmailForm = ({ onEmailSubmit, disabled }: any) => {
  const [user, setUser] = useContext(UserContext);

  const navigate = useNavigate();
  const [account, setAccount] = useState('');
  const [magic, setMagic] = useState<any>(null);
  const [web3, setWeb3] = useState<any>(null);
  const [email, setEmail] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalTitle = "The Value of Purpose";
  const modalDescription = "Purpose provides direction and focus for the development of decentralized systems and applications.";

  // Initialize Magic and Web3 on component mount
  useEffect(() => {
    const magic = new Magic(magicKey, {
      extensions: [new OAuthExtension()],
    });
    setMagic(magic);
  }, []);

  // Login with Magic and fetch accounts
  const getAccounts = async () => {
    if (magic) {
      try {
        let didToken = await magic.auth.loginWithEmailOTP({ email });
        if (didToken) {
          const userMetadata = await magic.user.getMetadata();
          setAccount(userMetadata.publicAddress);
          axios
            .post(
              `${serverLink}/auth`,
              {
                email: email,
              },
              {
                params: {
                  magicAccount: userMetadata.publicAddress,
                },
              }
            )
            .then((response) => {
              if (response.data.Message == "login") {
                setUser({
                  userId: response.data.data._id,
                  userName: response.data.data.name,
                  magicLinkAccount: account,
                });
                navigate("/profile");
              } else if (response.data.Message == "register") {
                navigate("/keep-in-touch");
              } else if (response.data.Message == "failed") {
                toast("Login Failed!");
              }
            });
        }

      } catch (error) {
        console.error("Error logging in:", error);
      }
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    onEmailSubmit(email);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} className='h-80 w-80 my-40 border rounded-3xl p-3 bg-white text-center border-gray-100 shadow-lg mx-auto d-flex flex-column justify-content-space-between py-2'>
        <h2 className="font-bold text-center text-black pt-4 py-2">{modalTitle}</h2>
        <p className="text-black">{modalDescription}</p>
        <div className="d-flex justify-center py-2">
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => setIsModalOpen(false)}>Close</button>
        </div>
      </Modal>







      <ToastContainer toastStyle={{ backgroundColor: "#000000" }} />
      <form onSubmit={handleSubmit} className="px-8 pt-6 pb-8 mb-4">
        <h3 className="mb-4 text-2xl">Login</h3>
        <div>
          <input
            className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2"
            placeholder="Email Address*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mt-6">
          <button
            onClick={getAccounts}
            className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500  hover:to-indigo-500 hover:via-purple-500 hover:from-pink-500 hover:shadow-lg  text-black font-bold py-3 px-8 focus:outline-none focus:shadow-outline rounded-3xl"
          >
            Let's go
          </button>
          <button className="text-white px-6 py-2" onClick={() => setIsModalOpen(true)}>Need help?</button>
        </div>
      </form>
    </>
  );
};

export default EmailForm;
